
export const computeVelocity = (d1, slope, k) => {
  const a = Math.sqrt((2 * 9.81 * (d1 / 1000) * (slope / 1000)))
  const visk = 1.30969023618571e-06
  const b = -2 * Math.log10((2.51 * visk) / (d1 / 1000 * a) + k / 1000 / (3.71 * d1 / 1000))
  return a * b
}

export const computeCapacity = (d1, v) => {
  return Math.PI * Math.pow(d1 / 1000 / 2, 2) * v * 1000
}

export const fillTable = {
  0: { h: 0, v: 0 },
  1: { h: 0.07, v: 0.3 },
  2: { h: 0.1, v: 0.4 },
  3: { h: 0.12, v: 0.46 },
  4: { h: 0.14, v: 0.49 },
  5: { h: 0.16, v: 0.52 },
  6: { h: 0.17, v: 0.545 },
  7: { h: 0.18, v: 0.57 },
  8: { h: 0.194, v: 0.595 },
  9: { h: 0.21, v: 0.62 },
  10: { h: 0.22, v: 0.636 },
  11: { h: 0.23, v: 0.652 },
  12: { h: 0.236, v: 0.668 },
  13: { h: 0.243, v: 0.684 },
  14: { h: 0.255, v: 0.7 },
  15: { h: 0.265, v: 0.713 },
  16: { h: 0.271, v: 0.727 },
  17: { h: 0.28, v: 0.74 },
  18: { h: 0.289, v: 0.753 },
  19: { h: 0.296, v: 0.767 },
  20: { h: 0.304, v: 0.78 },
  21: { h: 0.312, v: 0.77 },
  22: { h: 0.32, v: 0.781 },
  23: { h: 0.328, v: 0.792 },
  24: { h: 0.334, v: 0.803 },
  25: { h: 0.341, v: 0.814 },
  26: { h: 0.349, v: 0.84 },
  27: { h: 0.355, v: 0.835 },
  28: { h: 0.362, v: 0.844 },
  29: { h: 0.37, v: 0.853 },
  30: { h: 0.376, v: 0.861 },
  31: { h: 0.383, v: 0.87 },
  32: { h: 0.39, v: 0.879 },
  33: { h: 0.396, v: 0.888 },
  34: { h: 0.403, v: 0.9 },
  35: { h: 0.41, v: 0.906 },
  36: { h: 0.416, v: 0.912 },
  37: { h: 0.421, v: 0.919 },
  38: { h: 0.43, v: 0.926 },
  39: { h: 0.436, v: 0.932 },
  40: { h: 0.441, v: 0.939 },
  41: { h: 0.447, v: 0.945 },
  42: { h: 0.452, v: 0.95 },
  43: { h: 0.458, v: 0.958 },
  44: { h: 0.464, v: 0.964 },
  45: { h: 0.47, v: 0.972 },
  46: { h: 0.475, v: 0.977 },
  47: { h: 0.48, v: 0.982 },
  48: { h: 0.486, v: 0.988 },
  49: { h: 0.493, v: 0.994 },
  50: { h: 0.5, v: 1 },
  51: { h: 0.505, v: 1.004 },
  52: { h: 0.51, v: 1.008 },
  53: { h: 0.516, v: 1.012 },
  54: { h: 0.522, v: 1.019 },
  55: { h: 0.53, v: 1.025 },
  56: { h: 0.53, v: 1.029 },
  57: { h: 0.54, v: 1.032 },
  58: { h: 0.547, v: 1.04 },
  59: { h: 0.553, v: 1.045 },
  60: { h: 0.56, v: 1.05 },
  61: { h: 0.566, v: 1.055 },
  62: { h: 0.572, v: 1.06 },
  63: { h: 0.579, v: 1.065 },
  64: { h: 0.585, v: 1.069 },
  65: { h: 0.589, v: 1.073 },
  66: { h: 0.592, v: 1.077 },
  67: { h: 0.6, v: 1.07 },
  68: { h: 0.605, v: 1.086 },
  69: { h: 0.61, v: 1.089 },
  70: { h: 0.615, v: 1.08 },
  71: { h: 0.621, v: 1.095 },
  72: { h: 0.628, v: 1.098 },
  73: { h: 0.634, v: 1.09 },
  74: { h: 0.64, v: 1.106 },
  75: { h: 0.645, v: 1.109 },
  76: { h: 0.65, v: 1.1 },
  77: { h: 0.665, v: 1.116 },
  78: { h: 0.662, v: 1.119 },
  79: { h: 0.669, v: 1.122 },
  80: { h: 0.675, v: 1.11 },
  81: { h: 0.68, v: 1.129 },
  82: { h: 0.686, v: 1.132 },
  83: { h: 0.692, v: 1.135 },
  84: { h: 0.7, v: 1.12 },
  85: { h: 0.705, v: 1.141 },
  86: { h: 0.712, v: 1.143 },
  87: { h: 0.719, v: 1.146 },
  88: { h: 0.726, v: 1.148 },
  89: { h: 0.732, v: 1.15 },
  90: { h: 0.74, v: 1.151 },
  91: { h: 0.748, v: 1.13 },
  92: { h: 0.755, v: 1.155 },
  93: { h: 0.76, v: 1.158 },
  94: { h: 0.77, v: 1.16 },
  95: { h: 0.777, v: 1.161 },
  96: { h: 0.783, v: 1.163 },
  97: { h: 0.79, v: 1.165 },
  98: { h: 0.8, v: 1.166 },
  99: { h: 0.81, v: 1.167 },
  100: { h: 0.82, v: 1.168 },
  101: { h: 0.83, v: 1.169 },
  102: { h: 0.84, v: 1.17 },
  103: { h: 0.85, v: 1.14 },
  104: { h: 0.86, v: 1.169 },
  105: { h: 0.87, v: 1.13 },
  106: { h: 0.88, v: 1.12 },
  107: { h: 0.895, v: 1.1 }
}
